import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';

export function entityAdapter<T extends {_id?: string}>(sortComparer?) {
    const adapter: {selectId?, sortComparer? } = {
        selectId: obj => obj._id,
    };
    if (sortComparer) {
        adapter.sortComparer = sortComparer;
    }
    return createEntityAdapter<T>(adapter);
}
